export default {

    init() {
        this.headerMenu();
        this.initLogIn();
        this.initForgotPass();
        this.initRegistration();
        this.mobileSearch();
        this.notificationsDropdown();
    },

    headerMenu() {
        $('.hamburger').on('click', function () {
            let mobMenu = $(this).closest('body').find('.side-menu');
            if (mobMenu.hasClass('active')) {
                $(this).removeClass('is-active');
                mobMenu.removeClass('active');
            } else {
                //mobMenu.slideDown(300);
                mobMenu.addClass('active');
                $(this).addClass('is-active');
            }
        });

        $('.mobile-log').on('click', function () {
            let mobMenu = $('.side-menu');
            if (mobMenu.hasClass('active')) {
                $('.hamburger').removeClass('is-active');
                mobMenu.removeClass('active');
            }
        });

    },


    initLogIn() {
        let logInPopUp = $('.cl-log-in.log-in.pop-up');

        $('.log-in-btn').on('click', function () {
            logInPopUp.fadeIn(200);
        });

        $('.cl-log-in.log-in.pop-up .cl-log-in--content-close').on('click', function () {
            logInPopUp.fadeOut(200);
        });

        $('.log-in-redirect-btn').on('click', function () {
            $('.cl-log-in').hide(0);
            logInPopUp.fadeIn(0);
        });


    },

    initForgotPass() {
        let forgotPassPopUp = $('.cl-log-in.forgot-pass.pop-up');

        $('.cl-log-in.forgot-pass.pop-up .cl-log-in--content-close').on('click', function () {
            forgotPassPopUp.fadeOut(200);
        });

        $('.forgot-pass-redirect-btn').on('click', function () {
            $('.cl-log-in').hide(0);
            forgotPassPopUp.fadeIn(0);
        });


    },

    initRegistration() {
        let registrationPopUp = $('.cl-log-in.registration.pop-up');

        $('.sign-up-btn').on('click', function () {
            registrationPopUp.fadeIn(200);
            registrationPopUp.addClass('active');
            if ($('.cl-log-in--form .regular-select select').data('select2')) {
                $('.cl-log-in--form .regular-select select').select2('destroy');
            }
            $('.cl-log-in--form .regular-select select').select2();

            const self = this;
            let fileTypes = ['jpg', 'jpeg', 'png'];
            let maxAllowedSize = 16 * 1024 * 1024;
            let wrongFile = $('.fr-registration.pop-up .product-photo-upload-wrap--upload-row .wrong-file-type');
            let uploadArea = $('.fr-registration.pop-up .product-photo-upload-wrap--upload-box');
            let filesList = $('.fr-registration.pop-up .product-photo-upload-wrap--list');
            let explorerCheck = false;
            let safariCheck = false;

            if (navigator.userAgent.indexOf('Trident/') !== -1) {
                explorerCheck = true;
            } else {
                explorerCheck = false;
            }

            if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
                safariCheck = true;
            } else {
                safariCheck = false;
            }

            if (!safariCheck && !explorerCheck) {
                // Drag and drop
                window.addEventListener('dragenter', preventDefaults, false);
                window.addEventListener('dragleave', preventDefaults, false);
                window.addEventListener('dragover', preventDefaults, false);
                window.addEventListener('drop', preventDefaults, false);

                window.addEventListener('dragover', highlight, false);
                window.addEventListener('drop', dropFiles, false);
            } else {
            }

            function preventDefaults(e) {
                e.preventDefault();
                e.stopPropagation();
            }

            function highlight() {
                if ($('.cl-log-in.registration.pop-up').hasClass('active')) {
                    $('.drag-and-drop-toggle.drop-pop-up').show();
                }
            }

            function dropFiles(e) {
                if ($('.cl-log-in.registration.pop-up').hasClass('active')) {
                    $('.drag-and-drop-toggle.drop-pop-up').hide();

                    //If delete previous import
                    filesList.empty();

                    let filesAllowed = [];
                    let files = e.dataTransfer.files;
                    let countInvalid = false;

                    for (let i = 0; i < files.length; i++) {
                        if (files[i].size < maxAllowedSize) {
                            let extension = files[i].name.split('.').pop().toLowerCase();
                            let isSuccess = fileTypes.indexOf(extension) > -1;
                            if (isSuccess) {
                                filesAllowed.push(files[i]);
                            } else {
                                countInvalid = true;
                            }
                        } else {
                            countInvalid = true;
                        }
                    }

                    if (countInvalid == true) {
                        uploadArea.addClass('invalid');
                        wrongFile.slideDown(300);
                    } else {
                        wrongFile.slideUp(300);
                        uploadArea.removeClass('invalid');
                    }

                    generateFileList(filesAllowed);
                    document.querySelector('.fr-registration.pop-up .product-img-file').files = new FileListItem(filesAllowed);
                }

                function generateFileList(files) {
                    for (let file of files) {
                        let numberOfChildren = filesList.children().length;
                        if (numberOfChildren < 30) {
                            filesList.append(`<div class="item">"${file.name}" <span data-name="${file.name}"></span></div>`);
                        }
                    }
                }

                function FileListItem(a) {
                    a = [].slice.call(Array.isArray(a) ? a : arguments)
                    for (var c, b = c = a.length, d = !0; b-- && d;) d = a[b] instanceof File
                    if (!d) throw new TypeError("expected argument to FileList is File or array of File objects")
                    for (b = (new ClipboardEvent("")).clipboardData || new DataTransfer; c--;) b.items.add(a[c])
                    return b.files
                }
            }
        });


        $('.sign-up-redirect-btn').on('click', function () {
            $('.cl-log-in').hide(0);
            registrationPopUp.fadeIn(0);
            registrationPopUp.addClass('active');
            if ($('.cl-log-in--form .regular-select select').data('select2')) {
                $('.cl-log-in--form .regular-select select').select2('destroy');
            }
            $('.cl-log-in--form .regular-select select').select2();

            const self = this;
            let fileTypes = ['jpg', 'jpeg', 'png'];
            let maxAllowedSize = 16 * 1024 * 1024;
            let wrongFile = $('.fr-registration.pop-up .product-photo-upload-wrap--upload-row .wrong-file-type');
            let uploadArea = $('.fr-registration.pop-up .product-photo-upload-wrap--upload-box');
            let filesList = $('.fr-registration.pop-up .product-photo-upload-wrap--list');
            let explorerCheck = false;
            let safariCheck = false;

            if (navigator.userAgent.indexOf('Trident/') !== -1) {
                explorerCheck = true;
            } else {
                explorerCheck = false;
            }

            if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
                safariCheck = true;
            } else {
                safariCheck = false;
            }

            if (!safariCheck && !explorerCheck) {
                // Drag and drop
                window.addEventListener('dragenter', preventDefaults, false);
                window.addEventListener('dragleave', preventDefaults, false);
                window.addEventListener('dragover', preventDefaults, false);
                window.addEventListener('drop', preventDefaults, false);

                window.addEventListener('dragover', highlight, false);
                window.addEventListener('drop', dropFiles, false);
            } else {
            }

            function preventDefaults(e) {
                e.preventDefault();
                e.stopPropagation();
            }

            function highlight() {
                if ($('.cl-log-in.registration.pop-up').hasClass('active')) {
                    $('.drag-and-drop-toggle.drop-pop-up').show();
                }
            }

            function dropFiles(e) {
                if ($('.cl-log-in.registration.pop-up').hasClass('active')) {
                    $('.drag-and-drop-toggle.drop-pop-up').hide();

                    //If delete previous import
                    filesList.empty();

                    let filesAllowed = [];
                    let files = e.dataTransfer.files;
                    let countInvalid = false;

                    for (let i = 0; i < files.length; i++) {
                        if (files[i].size < maxAllowedSize) {
                            let extension = files[i].name.split('.').pop().toLowerCase();
                            let isSuccess = fileTypes.indexOf(extension) > -1;
                            if (isSuccess) {
                                filesAllowed.push(files[i]);
                            } else {
                                countInvalid = true;
                            }
                        } else {
                            countInvalid = true;
                        }
                    }

                    if (countInvalid == true) {
                        uploadArea.addClass('invalid');
                        wrongFile.slideDown(300);
                    } else {
                        wrongFile.slideUp(300);
                        uploadArea.removeClass('invalid');
                    }

                    generateFileList(filesAllowed);
                    document.querySelector('.fr-registration.pop-up .product-img-file').files = new FileListItem(filesAllowed);
                }

                function generateFileList(files) {
                    for (let file of files) {
                        let numberOfChildren = filesList.children().length;
                        if (numberOfChildren < 30) {
                            filesList.append(`<div class="item">"${file.name}" <span data-name="${file.name}"></span></div>`);
                        }
                    }
                }

                function FileListItem(a) {
                    a = [].slice.call(Array.isArray(a) ? a : arguments)
                    for (var c, b = c = a.length, d = !0; b-- && d;) d = a[b] instanceof File
                    if (!d) throw new TypeError("expected argument to FileList is File or array of File objects")
                    for (b = (new ClipboardEvent("")).clipboardData || new DataTransfer; c--;) b.items.add(a[c])
                    return b.files
                }
            }
        });



        $('.cl-log-in.registration.pop-up .cl-log-in--content-close').on('click', function () {
            registrationPopUp.fadeOut(200);
            registrationPopUp.removeClass('active');
            $('.drag-and-drop-toggle.drop-pop-up').hide();
        });
    },

    mobileSearch() {
        if ($(window).width() < 768) {
            $(document).on("click", function (event) {
                if ($(event.target).closest(".fr-header--search").length === 0) {
                    $('.fr-header--body').removeClass('search-mobile-expand');
                } else {
                    $('.fr-header--body').addClass('search-mobile-expand');
                }
            });
        }
    },


    notificationsDropdown() {
        $('.notifications').on('click', function(){
            $(this).find('.notifications-dropdown').toggleClass('active');
        });
    }

}